import React, {useMemo} from 'react';
import PropTypes from "prop-types";

import NavBarSuperior from "../NavBarSuperior/NavBarSuperior";
import Header from "./components/Header";
import Lanes from "./components/Lanes";
import FooterHome from '../Home/FooterHome';
import PageCalendar from './pages/Calendar';
import PageTimeline from './pages/Timeline';
import PageGradesAndAbsences from './pages/GradesAndAbsences';

import * as Styles from './styles';


const PAGES = {
  HOME: 'HOME',
  CALENDAR: 'CALENDAR',
  TIMELINE: 'TIMELINE',
  GRANDESANDABSENCES: 'GRANDESANDABSENCES'
}

function Screen({turma, activePage, selectPage}) {
  const renderPage = useMemo(() => {
    switch (activePage) {
      case PAGES.HOME:
        return <Lanes turma={turma} selectPage={selectPage}/>;
      case PAGES.CALENDAR:
        return <PageCalendar turma={turma} />;
      case PAGES.TIMELINE:
        return <PageTimeline turma={turma} />;
      case PAGES.GRANDESANDABSENCES:
        return <PageGradesAndAbsences turma={turma} />;
      default:
        return null;
    }
  }, [activePage, turma]);
  return (
  <>
    <NavBarSuperior />
    <Styles.Container>
    <Header turma={turma} activePage={activePage} selectPage={selectPage}/>
      <Styles.Content>
        {renderPage}
      </Styles.Content>
    </Styles.Container>
    <div style={{marginTop: '40px'}}>
      <FooterHome />
    </div>
  </>
  );
}

Screen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  turma: PropTypes.object.isRequired,
  activePage: PropTypes.string.isRequired,
  selectPage: PropTypes.func.isRequired
};

export default Screen;
